const sharedStringsStrings = {
    placeOrder: "Hacer Pedido",
    viewMenu: "Ver Menú",
    takeMeThere: "Cómo llegar",
};

export default sharedStringsStrings;
